import { render, staticRenderFns } from "./TryQuestion.vue?vue&type=template&id=23cb2e2c&lang=true&"
import script from "./TryQuestion.vue?vue&type=script&lang=js&"
export * from "./TryQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TryQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports